import { Partners } from '@platform/client';
import { useParams } from 'wouter';
import ErrorPage from '../../ErrorPage';
import { HeaderFooterLayout } from '../app';
import RootContainer from '../landing/RootContainer';
import SquareFeaturePanel from '../landing/SquareFeaturePanel';
import MetaTags from '../util/MetaTags';
import ParnerLandingHero from './ParnerLandingHero';
import PartnerLandingAboutSection from './PartnerLandingAboutSection';
import PartnerLandingCTACard from './PartnerLandingCTACard';
import { PartnerLandingFAQSection } from './PartnerLandingFAQSection';
import { PartnerLandingGainAccessSection } from './PartnerLandingGainAccessSection';
import { PartnerLandingHeroSkeleton } from './PartnerLandingHeroSkeleton';
import { PartnerLandingOpportunitySectionV2 } from './PartnerLandingOpportunitySectionV2';
import { PartnerLandingTestimonialSection } from './PartnerLandingTestimonialSection';
import { PartnerLandingTrustedBySection } from './PartnerLandingTrustedBySection';
import { PartnerLandingWhoYoullWorkWithSection } from './PartnerLandingWhoYoullWorkWithSection';
import { ROUTES } from '../routes/consts';

const PartnerLandingPageV2 = () => {
  const { impactPartnerName } = useParams<{ impactPartnerName: string }>();
  const { isSuccess, isError, data } = Partners.useGetImpactPartner(impactPartnerName);
  const RepMockupMobile =
    'https://movingworldspublic.blob.core.windows.net/public/landing/rep/rep-mockup-mobile.webp';
  const RepMockupDesktop =
    'https://movingworldspublic.blob.core.windows.net/public/landing/rep/rep-mockup-desktop.webp';

  if (isError) {
    return <ErrorPage />;
  }

  return (
    <HeaderFooterLayout>
      <MetaTags
        title='Make a real impact with your professional skills benefitting our world'
        description='Find opportunities to make a real social impact with your professional skills to make a difference supporting our world'
      />
      <RootContainer>
        {!isSuccess ?
          <PartnerLandingHeroSkeleton />
          : <>
            <ParnerLandingHero partner={data.impactPartner} />
            <PartnerLandingOpportunitySectionV2 partner={data.impactPartner} />
            <PartnerLandingGainAccessSection partner={data.impactPartner} />
            <SquareFeaturePanel
              title='How it Works'
              description='A proven process, guided by technology and backed by real people who care about your growth.'
              items={[
                {
                  title: 'Share your business needs',
                  description:
                    "From marketing to business strategy, tell us what challenge you're working on.",
                },
                {
                  title: 'Post a project',
                  description:
                    'Our tools make it easy to create a project that fits your goals and schedule.',
                },
                {
                  title: 'Collaborate on a solution',
                  description:
                    'Get hands-on support from skilled professionals plus tailored learning resources and events.',
                },
                {
                  title: 'Tap into new connections',
                  description:
                    "Get curated access to funders, buyers, and ecosystem partners when you're ready.",
                },
              ]}
              mobileImage={RepMockupMobile}
              desktopImage={RepMockupDesktop}
              isNumeric
              imageBgColor='light-gray'
            />
            <PartnerLandingWhoYoullWorkWithSection />
            <PartnerLandingCTACard
              title='Find the connections you need'
              description='Meet the right people—skilled volunteers, partners, and market connections ready to help.'
              signUpUrl={`${ROUTES.AUTH}${ROUTES.SIGN_UP}${ROUTES.SIGN_UP_REP}?impact=${data.impactPartner.id}`}
            />
            <PartnerLandingTrustedBySection />
            <PartnerLandingTestimonialSection />
            <PartnerLandingAboutSection
              signUpUrl={`${ROUTES.AUTH}${ROUTES.SIGN_UP}${ROUTES.SIGN_UP_REP}?impact=${data.impactPartner.id}`}
            />
            <PartnerLandingFAQSection partnerName={data.impactPartner.name} />
          </>
        }
      </RootContainer>
    </HeaderFooterLayout>
  );
};

export default PartnerLandingPageV2;
